import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getHistoricalData = store => store[NAME].historicalData;
export const getRecipientsList = store => store[NAME].recipientsList;
export const getConsent = store => store[NAME].consent;
export const getExchangeForMoneyData = store => store[NAME].exchangeForMoneyData;
